
import {Component, Prop} from 'vue-property-decorator'
import BaseForm from '@/components/forms/BaseForm'
import BaseFormContainer from '@/containers/base/BaseFormContainer.vue'
import {required} from 'vuelidate/lib/validators'
import MailSujetModel from '@/models/MailSujetModel'

@Component({
  components: {
    BaseFormContainer
  },
  validations: {
    form: {
      LIBELLE: {
        required
      }
    }
  }
})
export default class MailSujetForm extends BaseForm {
  model = MailSujetModel
}
